import { reverse, sortBy } from 'lodash';
// material
import { styled, useTheme } from '@mui/material/styles';
import { Box, Card, CardHeader, Typography, Stack } from '@mui/material';
// utils
import { fNumber } from '../../../../utils/formatNumber';
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const IconWrapperStyle = styled('div')(() => ({
  // width: 24,
  height: 24,
  display: 'flex',
  //  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: -5.5,
  marginLeft: -5.5,
  //  paddingLeft: theme.spacing(-5),
  // paddingRight: -2,
  marginTop: -1.5,
  paddingTop: -4
  // color: theme.palette.success.main
  //  backgroundColor: alpha(theme.palette.success.main, 0.16)
}));

// ----------------------------------------------------------------------

const POPULATION = reverse(
  sortBy(
    [
      { label: 'Hospital without payment', value: 1352773, color: '' },
      { label: 'Hospital with payment', value: 1539601, color: '' }
    ],
    'value'
  )
);

export default function PopulationWidget() {
  const theme = useTheme();

  const colors = [
    theme.palette.primary.main,
    '#ed1b2e', // theme.palette.chart.yellow[0],
    theme.palette.chart.blue[0],
    theme.palette.chart.violet[0],
    theme.palette.chart.green[0],
    theme.palette.chart.red[0]
  ];

  const total = POPULATION.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <Card sx={{ display: 'flex', alignItems: 'center', p: 3, mt: 1 }}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="overline" sx={{ color: 'text.secondary' }} component="p">
          POPULATION
        </Typography>

        <Stack direction="row" alignItems="center" flexWrap="wrap">
          <Box
            component="div"
            children={
              <CardHeader
                sx={{
                  padding: 0
                }}
                disableTypography={false}
                titleTypographyProps={{
                  color: 'textSecondary',
                  variant: 'caption',
                  marginLeft: -1.5,
                  marginBottom: -1,
                  marginTop: 1
                }}
                subheaderTypographyProps={{
                  color: 'textPrimary',
                  variant: 'h3',
                  marginLeft: -1.5
                }}
                avatar={
                  <IconWrapperStyle
                    sx={{
                      color: '#C4CDD5'
                    }}
                  >
                    <Iconify icon="clarity:group-solid" width={52} height={52} />
                  </IconWrapperStyle>
                }
                title="Total catchment population"
                subheader={fNumber(total)}
              />
            }
          />
        </Stack>
        {POPULATION.map((population, pI) => (
          <Stack key={`population-${pI}`} direction="row" alignItems="flex-start" flexWrap="wrap">
            {Array(
              Math.round((population.value / POPULATION[0].value) * 24) < 1
                ? 1
                : Math.round((population.value / POPULATION[0].value) * 24)
            )
              .fill()
              .map((pop, popI) => (
                <IconWrapperStyle
                  key={`popIcon-${popI}`}
                  sx={{
                    color: population.color === '' || population.color === undefined ? colors[pI] : population.color
                  }}
                >
                  <Iconify icon="ion:man" width={21} height={21} />
                </IconWrapperStyle>
              ))}
          </Stack>
        ))}
        <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap">
          {POPULATION.map((population, pI) => (
            <Typography
              key={`population-legende-${pI}`}
              component="div"
              children={
                <CardHeader
                  sx={{
                    padding: 0
                  }}
                  disableTypography={false}
                  titleTypographyProps={{
                    color: 'textSecondary',
                    variant: 'caption',
                    fontSize: 9,
                    marginLeft: -1.2,
                    marginTop: 1
                  }}
                  subheaderTypographyProps={{
                    color: 'textPrimary',
                    variant: 'caption',
                    marginLeft: -1.2,
                    marginTop: 0,
                    fontSize: 10
                  }}
                  avatar={
                    <IconWrapperStyle
                      sx={{
                        marginTop: 0.8,
                        color: population.color === '' || population.color === undefined ? colors[pI] : population.color
                      }}
                    >
                      <Iconify icon="ic:baseline-circle" width={12} height={12} />
                    </IconWrapperStyle>
                  }
                  title={population.label}
                  subheader={fNumber(population.value)}
                />
              }
            />
          ))}
        </Stack>
      </Box>
    </Card>
  );
}
